module.exports = __webpack_public_path__ + "media/packs/images/flags/CW-3a99017813c669258d6df2d09c4e2cd1.png";